import { type VariantProps, cva } from 'class-variance-authority';
import { cn } from '@/utils/сn';

export const dotsTriggerStyles = cva('inline-flex items-center justify-center cursor-pointer transition-colors', {
  variants: {
    intent: {
      default: 'rounded hover:bg-blue-50 h-6 w-6',
      bordered: 'rounded border border-blue-300 hover:bg-grey-100 min-w-10 h-10',
    },
    orientation: {
      vertical: 'flex-col gap-0.75',
      horizontal: 'flex-row gap-1',
    },
  },
  defaultVariants: {
    intent: 'default',
    orientation: 'vertical',
  },
});

const dotStyles = cva('rounded-full', {
  variants: {
    orientation: {
      vertical: 'size-0.75 bg-black',
      horizontal: 'w-1 h-1 bg-blue-300',
    },
  },
  defaultVariants: {
    orientation: 'vertical',
  },
});

export interface DotsTriggerProps extends VariantProps<typeof dotsTriggerStyles> {
  className?: string;
  'aria-label'?: string;
}

export function DotsTrigger({ className, intent, orientation, 'aria-label': ariaLabel }: DotsTriggerProps) {
  return (
    <button type="button" aria-label={ariaLabel} className={cn(dotsTriggerStyles({ intent, orientation }), className)}>
      <div className={dotStyles({ orientation })} />
      <div className={dotStyles({ orientation })} />
      <div className={dotStyles({ orientation })} />
    </button>
  );
}
